import { Plus, RotateCcw, Trash2 } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

import { api } from "@/api";
import { formatError } from "@/auth";

const update = (list, i, value) => list.map((x, j) => (j === i ? value : x));
const without = (list, i) => list.filter((_, j) => j !== i);

function ListField({ label, items, render, onAdd, testid }) {
  return (
    <fieldset className="guide-edit-list" data-testid={testid}>
      <legend>{label}</legend>
      {items.map(render)}
      <button type="button" className="link-button" onClick={onAdd} data-testid={`${testid}-add`}><Plus size={13} />Ajouter</button>
    </fieldset>
  );
}

const Remove = ({ onClick, testid }) => <button type="button" className="guide-edit-remove" onClick={onClick} title="Supprimer" data-testid={testid}><Trash2 size={13} /></button>;

export function GuideEditor({ page, onDone }) {
  const [f, setF] = useState({ title: page.title, purpose: page.purpose, steps: page.steps, checks: page.checks || [], limits: page.limits || [] });
  const [saving, setSaving] = useState(false);
  const set = (k, v) => setF({ ...f, [k]: v });
  const save = async () => {
    setSaving(true);
    try { await api.put(`/guide/${page.slug}`, f); toast.success("Fiche enregistrée."); onDone(); } catch (e) { toast.error(formatError(e.response?.data?.detail)); } finally { setSaving(false); }
  };
  const reset = async () => {
    if (!window.confirm("Remettre le texte d'origine de cette fiche ? Vos modifications seront perdues.")) return;
    await api.post(`/guide/${page.slug}/reset`);
    toast.success("Texte d'origine rétabli.");
    onDone();
  };
  return (
    <div className="guide-editor" data-testid="guide-editor">
      <label>Titre<input value={f.title} onChange={(e) => set("title", e.target.value)} data-testid="guide-edit-title" /></label>
      <label>À quoi ça sert<textarea rows={3} value={f.purpose} onChange={(e) => set("purpose", e.target.value)} data-testid="guide-edit-purpose" /></label>
      <ListField label="Étapes" items={f.steps} testid="guide-edit-steps" onAdd={() => set("steps", [...f.steps, { text: "" }])} render={(s, i) => (
        <div key={i} className="guide-edit-row"><b>{i + 1}</b><textarea rows={3} value={s.text} onChange={(e) => set("steps", update(f.steps, i, { ...s, text: e.target.value }))} data-testid={`guide-edit-step-${i}`} />{s.image && <small>capture</small>}<Remove onClick={() => set("steps", without(f.steps, i))} testid={`guide-edit-step-remove-${i}`} /></div>
      )} />
      <ListField label="Vérifier que ça marche" items={f.checks} testid="guide-edit-checks" onAdd={() => set("checks", [...f.checks, { test: "", expected: "" }])} render={(c, i) => (
        <div key={i} className="guide-edit-row guide-edit-check"><input value={c.test} placeholder="Test à faire" onChange={(e) => set("checks", update(f.checks, i, { ...c, test: e.target.value }))} data-testid={`guide-edit-check-test-${i}`} /><input value={c.expected} placeholder="Résultat attendu" onChange={(e) => set("checks", update(f.checks, i, { ...c, expected: e.target.value }))} data-testid={`guide-edit-check-expected-${i}`} /><Remove onClick={() => set("checks", without(f.checks, i))} testid={`guide-edit-check-remove-${i}`} /></div>
      )} />
      <ListField label="Limites connues" items={f.limits} testid="guide-edit-limits" onAdd={() => set("limits", [...f.limits, ""])} render={(l, i) => (
        <div key={i} className="guide-edit-row"><textarea rows={2} value={l} onChange={(e) => set("limits", update(f.limits, i, e.target.value))} data-testid={`guide-edit-limit-${i}`} /><Remove onClick={() => set("limits", without(f.limits, i))} testid={`guide-edit-limit-remove-${i}`} /></div>
      )} />
      <div className="guide-edit-footer">
        <button type="button" className="link-button" onClick={reset} data-testid="guide-edit-reset"><RotateCcw size={13} />Texte d'origine</button>
        <button type="button" className="secondary-button" onClick={onDone} data-testid="guide-edit-cancel">Annuler</button>
        <button type="button" className="primary-button" disabled={saving || !f.title.trim()} onClick={save} data-testid="guide-edit-save">{saving ? "Enregistrement…" : "Enregistrer"}</button>
      </div>
    </div>
  );
}
